module.exports = __webpack_public_path__ + "static/media/index.cf15c528.jpg";